
interface CompanyOnlinePresenceCardProps {
  website: string | null | undefined;
  twitterUrl: string | null | undefined;
  instagramUrl: string | null | undefined;
  linkedinUrl: string | null | undefined;
}

export function CompanyOnlinePresenceCard({
  website,
  twitterUrl,
  instagramUrl,
  linkedinUrl
}: CompanyOnlinePresenceCardProps) {
  return (
    <div>
      <h3 className="text-lg font-medium mb-2">Online Presence</h3>
      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <p className="text-sm text-muted-foreground">Website</p>
          <p className="font-medium">
            {website ? (
              <a href={website} target="_blank" rel="noopener noreferrer" 
                className="text-redflags-red hover:underline">
                {website}
              </a>
            ) : (
              'Not provided'
            )}
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">X (Twitter)</p>
          <p className="font-medium">
            {twitterUrl ? (
              <a href={twitterUrl} target="_blank" rel="noopener noreferrer"
                className="text-redflags-red hover:underline">
                {twitterUrl}
              </a>
            ) : (
              'Not provided'
            )}
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">Instagram</p>
          <p className="font-medium">
            {instagramUrl ? (
              <a href={instagramUrl} target="_blank" rel="noopener noreferrer"
                className="text-redflags-red hover:underline">
                {instagramUrl}
              </a>
            ) : (
              'Not provided'
            )}
          </p>
        </div>
        <div>
          <p className="text-sm text-muted-foreground">LinkedIn</p>
          <p className="font-medium">
            {linkedinUrl ? (
              <a href={linkedinUrl} target="_blank" rel="noopener noreferrer"
                className="text-redflags-red hover:underline">
                {linkedinUrl}
              </a>
            ) : (
              'Not provided'
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
